import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";

export default function Reserve() {
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/vehicles?category=suv")
      .then((res) => {
        const v = res.data?.[0];
        navigate(v ? `/fleet/${v.id}#request-quote` : "/fleet", { replace: true });
      })
      .catch(() => navigate("/fleet", { replace: true }));
  }, [navigate]);

  return (
    <div className="bg-background min-h-screen flex items-center justify-center" data-testid="reserve-redirect">
      <span className="font-mono text-sm tracking-widest gold-text animate-pulse">LOADING RESERVATION…</span>
    </div>
  );
}
